<template>
	<div class="wuxing-page">
		<div class="header-bar" @click="$router.back()">
			<van-icon name="arrow-left" class="back-icon" />
		</div>
		<div class="logo">
			<img :src="logoImg" alt="激活额度" />
		</div>

		<div class="content">
			<div class="totalWithdrawalLimit">
				<img :src="totalWithdrawalLimitImg" alt="可提现总额度" />
				<span class="money">￥ {{ formatAmount(remainingMoney) }}</span>
			</div>
			<div class="selectedAmount">
				<div class="selectedAmount-content">
					<div class="selectedAmount-label">已选择转入逐梦卡额度</div>
					<div class="selectedAmount-value">￥ {{ formatAmount(selectedAmount) }}</div>
				</div>
			</div>
			<img class="text" :src="textImg" alt="尊敬的持卡人" />

			<div class="quota-card" v-for="(item, idx) in items" :key="'r' + idx">
				<div class="card-content">
					<img class="card-image" :src="getCardImage(item.file)" :alt="item.alt" />
					<!-- 根据item.showCardOverlay的值判断显示哪一个 -->
					<img v-if="!item.showCardOverlay" class="image-overlay" :src="goOpenImg" alt="前往开通额度"
						@click="goToOnlinePayment(item.id)" />
					<div v-else class="card-overlay">
						<img :src="checkProgressImg" alt="查看进度" @click="$router.push('/electronicReceipt')" />
						<img v-if="item.file != '激活额度 (4).png'" :src="increaseCreditLimitImg" alt="增加额度"
							@click="goToOnlinePayment(item.id)" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Fetch from "../../utils/fetch";
	import logoImg from '@/assets/withdrawBankCard/logo2.png';
	import totalWithdrawalLimitImg from '@/assets/withdrawBankCard/total_withdrawal_limit.png';
	import textImg from '@/assets/withdrawBankCard/text.png';
	import goOpenImg from '@/assets/withdrawBankCard/go_open.png';
	import increaseCreditLimitImg from '@/assets/withdrawBankCard/increase_credit_limit.png';
	import checkProgressImg from '@/assets/withdrawBankCard/check_progress.png';
	// import iconBiImg from '@/assets/icon/icon_bi2.png';
	import {
		Icon,
		Dialog,
		Popup
	} from 'vant';

	export default {
		name: 'selectLimit',
		components: {
			[Icon.name]: Icon,
			[Popup.name]: Popup
		},
		data() {
			return {
				logoImg: logoImg,
				totalWithdrawalLimitImg: totalWithdrawalLimitImg,
				textImg: textImg,
				goOpenImg: goOpenImg,
				increaseCreditLimitImg: increaseCreditLimitImg,
				checkProgressImg: checkProgressImg,
				// iconBiImg: iconBiImg,
				money: 0.00,
				selectedAmount: 0.00,
				items: [{
						id: 2,
						file: '激活额度 (1).png',
						alt: '50万',
						showCardOverlay: false
					},
					{
						id: 3,
						file: '激活额度 (2).png',
						alt: '200万',
						showCardOverlay: false
					},
					{
						id: 4,
						file: '激活额度 (3).png',
						alt: '500万',
						showCardOverlay: false
					},
					{
						id: 5,
						file: '激活额度 (4).png',
						alt: '全部余额',
						showCardOverlay: false
					},
				],
			}
		},
		computed: {
			// 计算剩余可提现金额：money - selectedAmount，结果为负数则为0
			remainingMoney() {
				const moneyNum = parseFloat(this.money) || 0;
				const selectedNum = parseFloat(this.selectedAmount) || 0;
				const result = moneyNum - selectedNum;
				return result < 0 ? 0 : result;
			}
		},
		created() {
			this.$parent.footer('selectLimit', false);
		},
		mounted() {
			// 页面加载时获取数据
			this.initData();
			this.fetchReceiptData();
		},
		methods: {
			getCardImage(file) {
				try {
					return require(`@/assets/withdrawBankCard/${file}`)
				} catch (e) {
					console.warn('image not found:', file, e)
					return ''
				}
			},
			// 格式化金额显示，添加千分位分隔符
			formatAmount(amount) {
				// 确保金额是数字类型
				const num = parseFloat(amount);
				if (isNaN(num)) {
					return '0.00';
				}

				// 保留两位小数并添加千分位分隔符
				return num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
			},
			// 初始化数据
			async initData() {
				try {
					// 并行请求用户信息和额度激活状态
					const [userInfoRes, limitStatusRes] = await Promise.all([
						Fetch('/user/info'),
						Fetch('/user/get_limit_activation_status')
					]);

					// 处理用户信息
					if (userInfoRes.code === 1 && userInfoRes.data) {
						this.money = userInfoRes.data.money;
					}

					// 处理额度激活状态
					if (limitStatusRes.code === 1 && limitStatusRes.data) {
						this.updateShowCardOverlay(limitStatusRes.data);
					}
				} catch (error) {
					console.error('初始化数据失败:', error);
				}
			},
			fetchReceiptData() {
				Fetch("/user/get_receipt_data")
					.then(res => {
						if (res.code === 1) {
							this.selectedAmount = res.data.amount;
						} else {
							// this.$toast(res.msg || '获取回单数据失败');
						}
					}).catch(err => {
						console.error(err);
					})
			},
			// 根据接口返回的状态更新 showCardOverlay
			updateShowCardOverlay(statusData) {
				console.log('接口返回的状态数据:', statusData);
				console.log('更新前的items:', JSON.parse(JSON.stringify(this.items)));
				// 遍历 items，根据 statusData 完全覆盖 showCardOverlay 的值
				// !! 确保转换为布尔值，如果不存在则使用 false
				this.items.forEach(item => {
					item.showCardOverlay = !!statusData[item.id];
				});
				console.log('更新后的items:', JSON.parse(JSON.stringify(this.items)));
			},
			// 跳转到在线支付页面
			goToOnlinePayment(id) {
				this.$router.push({
					path: '/onlinePayment',
					query: {
						id: id
					}
				});
			},
		}
	}
</script>

<style lang="less" scoped>
	.wuxing-page {
		display: flex;
		text-align: center;
		align-items: center;
		flex-direction: column;
		height: 100vh;
		background-image: url('../../assets/withdrawBankCard/bg.png');
		background-size: cover;
		background-position: center;
		font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
		color: #333;
		position: relative;
		overflow: auto;
	}

	.header-bar {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 4.26667vw;
		padding-bottom: 0;
	}

	.header-bar .back-icon {
		font-size: 6.4vw;
		color: #fff;
		text-shadow: 0 1px .53333vw rgba(0, 0, 0, .3);
	}

	.logo {
		display: flex;
		justify-content: center;
		align-items: center;
		margin-bottom: 5vw;
	}

	.logo img {
		height: auto;
		width: 8rem;
		object-fit: contain;
		display: block;
	}

	.content {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		position: relative;
		width: 90%;
		margin-bottom: 5vw;

		.text {
			width: 100%;
			margin-bottom: 5vw;
		}

		.totalWithdrawalLimit {
			width: 100%;
			display: flex;
			justify-content: center;
			position: relative;
			margin-bottom: 5vw;

			img {
				width: 100%;
				max-width: 500px;
			}

			.money {
				position: absolute;
				top: 55%;
				left: 3%;
				font-size: 36px;
				font-weight: bold;
				color: #fff;
				text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
				white-space: nowrap;
			}
		}

		.selectedAmount {
			width: 100%;
			// max-width: 500px;
			margin-bottom: 5vw;
			background: linear-gradient(135deg, #ffd4d4 0%, #d0150f 100%);
			border-radius: 15px;
			padding: 4vw;
			box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
			// background-image: url('../../assets/icon/icon_bi2.png');

			.selectedAmount-content {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
				justify-content: center;

				.selectedAmount-label {
					font-size: 22px;
					color: #fff;
					font-weight: bold;
					letter-spacing: 2px;
					text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
					margin-bottom: 5vw;
				}

				.selectedAmount-value {
					font-size: 32px;
					color: #fff;
					font-weight: bold;
					text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
				}
			}
		}

		.quota-card {
			margin-bottom: 5vw;
			width: 100%;

			.card-content {
				position: relative;
				width: 100%;
				display: flex;
				justify-content: center;

				.card-image {
					width: 100%;
					max-width: 500px;
				}

				.image-overlay,
				.card-overlay {
					position: absolute;
					bottom: 5%;
					right: 0;
					width: 67.5%;
					height: 40%;
					object-fit: contain;
				}

				.image-overlay {
					cursor: pointer;
					/* 添加鼠标指针样式表示可点击 */
					transition: transform 0.2s ease;

					&:hover {
						transform: scale(1.02);
						/* 添加悬停效果 */
					}
				}

				.card-overlay {
					display: flex;
					justify-content: space-between;
					align-items: center;
					padding: 0 5%;

					img {
						width: 45%;
						height: auto;
						object-fit: contain;
						cursor: pointer;
						/* 添加鼠标指针样式表示可点击 */
						transition: transform 0.2s ease;

						&:hover {
							transform: scale(1.02);
							/* 添加悬停效果 */
						}
					}
				}
			}
		}
	}
</style>